import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../api';
import type { DmsState, UpdateDmsInput } from '../types';

export function useDms() {
  return useQuery({
    queryKey: ['dms'],
    queryFn: () => api.dms.get(),
  });
}

export function useUpdateDms() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateDmsInput) => api.dms.update(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['dms'] }),
  });
}

export function useCheckInDms() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.dms.checkIn(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['dms'] }),
  });
}

export type { DmsState };